// axios trigger
import axios from 'axios'
// Development
// const baseURL = 'https://phibasesuite.dev/api/v1'
console.info('axios url ',document.location.origin)
export default axios.create({
  // baseURL
  baseURL: `${document.location.origin}/api/v1`,
  // baseURL: `https://rsp.appdemo.sg/api/v1`,
  // You can add your headers heres
})
